import { faStar } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Rating = ({ className, rate, variant = "gold" })=>{
    const width = `${Math.min(10, Math.max(0, rate)) * 1.125}em`;
    return /*#__PURE__*/ React.createElement("div", {
        className: [
            "position-relative",
            "d-inline-block",
            className
        ].join(" ")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-body-secondary opacity-50 text-nowrap"
    }, /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    })), /*#__PURE__*/ React.createElement("div", {
        className: `text-${variant} position-absolute top-0 start-0 overflow-hidden text-nowrap`,
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    }), /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faStar
    })));
};

export { Rating };
//# sourceMappingURL=Rating.js.map
